import {useEffect, useState } from "react";
import ApiRequest from "../../helper/ApiRequest";
import { ApiEndpoints } from "../../helper/ApiEndpoints";
import DataTable from "../../component/DataTable";
import AdminHeader from "../../component/AdminHeader";
import { BaseUrl } from "../../helper/BaseUrl";

const applicationListEndpoint = ApiEndpoints.application.applicationList;

const tableHeader = ["Date", "Name", "email", "Mobile", "Apply For", "message", "resume",];
const tbody = ["createdAt", "name", "email", "phone", "vacancy", "message", "resume",];

export default function Career() {
    const [data, setData] = useState([]);

    const dataFetch = async () => {
    try {
        const response = await ApiRequest("GET", applicationListEndpoint);
        const result = response.jobs.map((item) => ({
        ...item,
        resume: item.resume ? (
            <a href={`${BaseUrl}${item.resume}`} target="_blank" rel="noopener noreferrer" download>
            <img src="/assets/view.webp" alt="view" style={{ width: "20px" }}/></a>
        ) : (
            "No file"
        ),
        }));

        setData(result);
    } catch (error) {
        console.log(error);
    }
    };


    useEffect(() => {
        dataFetch();
    }, []);

    const pagename = {
      name: 'Career',
      user: 'Admin',
      innerpage: 'Career'
    }


  return (
    <>
    <AdminHeader pagename={pagename}/>

    <div className="add-btn-section contact-manage-tab">
        <DataTable
          data={data}
          tableHeader={tableHeader}
          tbody={tbody}
          showAction={false}
        />
    </div>
    </>
  )
}
